import React from "react";
import { Row, Col, Divider, Card } from "antd";
import { StringIsNullOrEmpty } from "../../appRedux/actions";
import IntlMessages from "../../util/IntlMessages";
import Barcode from "react-barcode";
import { Switch } from "react-router-dom";
import { batch } from "react-redux";
import BarCodePreview from "./BarCodePreview";
 
function GetLabelClassandWidth(labelContentType) {
  let labelClass = "dk-sku-print-child-1-1";
  let barcodeWidth = 2;
  let barcodeHeight = 35;
  switch (labelContentType) {
    case 1:
      labelClass = "dk-sku-print-child-1-1";
      barcodeWidth = 5; //4
      barcodeHeight = 25;
      break;
    case 2:
      labelClass = "dk-sku-print-child-1-1";
      barcodeWidth = 3;
      barcodeHeight = 25;
      break;
    case 3:
      labelClass = "dk-sku-print-child-2-1";
      barcodeWidth = 2;
      barcodeHeight = 30;
      break;
    case 4:
      labelClass = "dk-sku-print-child-3-1";
      barcodeWidth = 2;
      barcodeHeight = 25;
      break;
    case 5:
      labelClass = "dk-sku-print-child-5-1";
      barcodeWidth = 2;
      barcodeHeight = 35;
      break;
    case 6:
      labelClass = "dk-sku-print-child-3-1";
      barcodeWidth = 2;
      barcodeHeight = 25;
      break;
    case 7:
      labelClass = "dk-sku-print-child-4-1";
      barcodeWidth = 2;
      barcodeHeight = 35;
      break;
    case 8:
      labelClass = "dk-sku-print-child-4-1";
      barcodeWidth = 1;
      barcodeHeight = 25;
      break;
    default:
      labelClass = "dk-sku-print-child-1-1";
      barcodeWidth = 2;
      barcodeHeight = 35;
      break;
  }
  let obj = {
    labelClass: labelClass,
    barcodeWidth: barcodeWidth,
    barcodeHeight: barcodeHeight,
  };
  return obj;
}
export class PrintBarcodes extends React.PureComponent {
  render() {
    const data = this.props.data ? this.props.data : false;
    const today = this.props.today ? this.props.today : false;
    const currencyCode = this.props.currData ? this.props.currData : "";
    const getCheckedLabelContent = this.props.labelPrintTypes
      ? this.props.labelPrintTypes
      : [];
    const labelType = this.props.labelType ? this.props.labelType : "1";
    return (
      <>
        {data ? (
          <div className="custom-print-outer-layout">
            {/* <Row className="custom-text-center mg-bt-20">
              <Col md={12}>{today}</Col>
              <Col md={12}>
                {<IntlMessages id="components.barcodegenerator.product" /> ||
                  "Dakar POS"}
              </Col>
            </Row> */}
            <div className={`${labelType == 5 ? "dk-sku-print-parent-5" : "dk-sku-print-parent"}`}>
              {data &&
                data.map((x) => {
                  let previewProductData = {
                    ProductName:
                      x && x.isVariant ? x.variantName : x.productName,
                    RetailPrice: `${currencyCode} ${x && x.retailPrice}`,
                    SKUCode: x && x.SKUCode,
                    batchNo : x && x.batchNo ? x.batchNo :""
                  };
                  let labelTypeDesignObj = GetLabelClassandWidth(labelType);
                  if(x.quantity == 0){
                    return <></>;
                  }
                  if (x.quantity == 1) {
                    return (
                      <div className={`${labelTypeDesignObj.labelClass}`}>
                        <BarCodePreview
                          labelContentVisible={getCheckedLabelContent}
                          productObj={previewProductData}
                          designObj={labelTypeDesignObj}
                        />
                      </div>
                    );
                  } else {
                    let barcodeData = [];
                    for (let i = 1; i <= x.quantity; i++) {
                      barcodeData.push(
                        <div className={`${labelTypeDesignObj.labelClass}`}>
                          <BarCodePreview
                            labelContentVisible={getCheckedLabelContent}
                            productObj={previewProductData}
                            designObj={labelTypeDesignObj}
                          />
                        </div>
                      );
                    }
                    return barcodeData;
                  }
                })}
            </div>
          </div>
        ) : (
          <h1>
            <IntlMessages id="components.barcodegenerator.connectionlost" />
          </h1>
        )}
      </>
    );
  }
}
